/* unplugin-vue-components disabled */import script from "./permission.vue?vue&type=script&setup=true&lang=ts"
export * from "./permission.vue?vue&type=script&setup=true&lang=ts"

import "./permission.vue?vue&type=style&index=0&id=018515ae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-018515ae"]])

export default __exports__